import { useEffect, useRef, useState } from 'react'

const SUGGESTION_DELAY_MS = 300
const MAX_SUGGESTIONS = 5

export default function useDebouncedSuggestions (loadSuggestions, query) {
  const [items, setItems] = useState([])
  const [open, setOpen] = useState(false)
  const [highlight, setHighlight] = useState(-1)
  const requestIdRef = useRef(0)
  const loadSuggestionsRef = useRef(loadSuggestions)

  loadSuggestionsRef.current = loadSuggestions

  useEffect(() => {
    const term = query.trim()
    if (!term) {
      setItems([])
      setOpen(false)
      setHighlight(-1)
      return undefined
    }

    const requestId = requestIdRef.current + 1
    requestIdRef.current = requestId
    setItems([])
    setOpen(false)
    setHighlight(-1)

    const timeoutId = setTimeout(() => {
      loadSuggestionsRef.current(term)
        .then((results) => {
          if (requestId !== requestIdRef.current) return
          const next = Array.isArray(results) ? results.slice(0, MAX_SUGGESTIONS) : []
          setItems(next)
          setHighlight(-1)
          setOpen(next.length > 0)
        })
        .catch(() => {
          if (requestId !== requestIdRef.current) return
          setItems([])
          setOpen(false)
          setHighlight(-1)
        })
    }, SUGGESTION_DELAY_MS)

    return () => {
      clearTimeout(timeoutId)
      requestIdRef.current += 1
    }
  }, [query])

  return { items, setItems, open, setOpen, highlight, setHighlight }
}
